
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"15","height":"15","rx":"3.5","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12.416 8.65H9.177v2.906H7.683V8.649H4.444V7.367h3.239V4.444h1.494v2.923h3.239v1.282z","fill":"currentColor"}})])
          )
        }
      }
    